import { ReferentielEnumDtoReferentialEnumCSVEnum } from 'lib_api/lib/api/gen';

import { DisplayableReferentielEnumCSV } from 'types/Referentiel';

import { csvReferentielNames } from './enumData';

/**
 * Map displayable name of CSV Referential with their corresponding enum value
 */
export function getCSVEnumWithDisplayableValue(): DisplayableReferentielEnumCSV {
  const displayableReferentielEnumCSV: DisplayableReferentielEnumCSV = {};

  return Object.values(ReferentielEnumDtoReferentialEnumCSVEnum).reduce(
    (acc, csvEnumValue) => {
      return {
        ...acc,
        [csvReferentielNames[csvEnumValue]]: csvEnumValue,
      };
    },
    displayableReferentielEnumCSV,
  );
}
